(() => {
  const init = (root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const hero = root.querySelector('[data-hero]');
    const sticky = root.querySelector('[data-sticky]');
    const variantInput = root.querySelector('[data-variant-input]');
    const atc = root.querySelector('[data-atc]');
    const stickyAtc = root.querySelector('[data-sticky-atc]');
    const form = root.querySelector('.af-product-form');
    const formError = root.querySelector('[data-form-error]');
    const videoTrigger = root.querySelector('[data-video-open]');
    const videoModal = root.querySelector('[data-video-modal]');
    const videoFrame = root.querySelector('[data-video-frame]');
    let videoReturnFocus = null;
    const packs = {
      2: { id: root.dataset.twoId, price: root.dataset.twoPrice, unitPrice: root.dataset.twoUnitPrice, pizzas: 2, servings: 6, available: root.dataset.twoAvailable === 'true' },
      4: { id: root.dataset.fourId, price: root.dataset.fourPrice, unitPrice: root.dataset.fourUnitPrice, pizzas: 4, servings: 12, available: root.dataset.fourAvailable === 'true' },
      6: { id: root.dataset.sixId, price: root.dataset.sixPrice, unitPrice: root.dataset.sixUnitPrice, pizzas: 6, servings: 18, available: root.dataset.sixAvailable === 'true' }
    };

    const selectPack = (size) => {
      const pack = packs[size];
      if (!pack || !pack.id) return;
      variantInput.value = pack.id;
      root.querySelectorAll('[data-pack]').forEach((button) => {
        const active = button.dataset.pack === String(size);
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      root.querySelectorAll('[data-price]').forEach((node) => { node.textContent = pack.price; });
      root.querySelector('[data-pack-summary]').textContent = `${pack.pizzas} pizzas · ${pack.servings} servings`;
      root.querySelector('[data-unit-price]').textContent = `${pack.unitPrice} per pizza`;
      const detail = `${size}-pack`;
      root.querySelector('[data-atc-detail]').textContent = `${detail} · ${pack.price}`;
      root.querySelector('[data-sticky-detail]').textContent = detail;
      atc.disabled = !pack.available;
      stickyAtc.disabled = !pack.available;
      if (!pack.available) atc.querySelector('span').textContent = 'Sold out';
      else atc.querySelector('span').textContent = 'Add to cart';
    };

    root.querySelectorAll('[data-pack]').forEach((button) => button.addEventListener('click', () => selectPack(button.dataset.pack)));

    const closeVideo = () => {
      if (!videoModal || videoModal.hidden) return;
      videoModal.hidden = true;
      videoFrame.replaceChildren();
      document.documentElement.classList.remove('af-video-open');
      videoReturnFocus?.focus();
    };

    if (videoTrigger && videoModal && videoFrame) {
      videoTrigger.addEventListener('click', () => {
        videoReturnFocus = videoTrigger;
        const iframe = document.createElement('iframe');
        iframe.src = videoTrigger.dataset.videoSrc;
        iframe.title = videoTrigger.getAttribute('aria-label');
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.allowFullscreen = true;
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        videoFrame.replaceChildren(iframe);
        videoModal.hidden = false;
        document.documentElement.classList.add('af-video-open');
        videoModal.querySelector('[data-video-close]').focus();
        window.dataLayer?.push({ event: 'adam_video_play', video_id: videoTrigger.dataset.videoId });
      });
      videoModal.querySelectorAll('[data-video-close]').forEach((button) => button.addEventListener('click', closeVideo));
      videoModal.addEventListener('click', (event) => { if (event.target === videoModal) closeVideo(); });
      document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeVideo(); });
    }

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (form.dataset.submitting === 'true') return;
      form.dataset.submitting = 'true';
      formError.hidden = true;
      [atc, stickyAtc].forEach((button) => button.setAttribute('aria-busy', 'true'));
      try {
        const drawer = document.querySelector('cart-drawer');
        const drawerSection = drawer?.closest('.shopify-section')?.id?.replace('shopify-section-', '');
        const sections = ['variant-added'];
        if (drawerSection) sections.push(drawerSection);
        const formData = new FormData(form);
        formData.set('sections', sections.join(','));
        formData.set('sections_url', `${window.Shopify.routes.root}variants/${variantInput.value}`);
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        });
        const added = await response.json();
        if (!response.ok) throw new Error(added.description || 'This pack could not be added to your cart.');
        const cart = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();
        cart.sections = added.sections || {};
        form.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: added.items || [added], cart } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart } }));
      } catch (error) {
        formError.textContent = error.message;
        formError.hidden = false;
      } finally {
        form.dataset.submitting = 'false';
        [atc, stickyAtc].forEach((button) => button.removeAttribute('aria-busy'));
      }
    });
    const observer = new IntersectionObserver(([entry]) => {
      const visible = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
      sticky.classList.toggle('is-visible', visible);
      sticky.setAttribute('aria-hidden', String(!visible));
    }, { threshold: 0 });
    observer.observe(hero);
    selectPack('2');
  };

  const start = () => document.querySelectorAll('[data-adam-fire]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
